import { useSearchParams } from 'react-router-dom';

export type LayoutType = {
  key: string;
  label: string;
  beta: boolean;
};

export const LAYOUTS = [
  { key: 'default', label: 'Default layout', beta: false },
  { key: 'simplified', label: 'Simplified layout', beta: false },
  { key: 'matchcontrol', label: 'Match control layout', beta: false },
  { key: 'quickcontrol', label: 'Quick control layout', beta: false },
  { key: 'playlist', label: 'Playlist layout', beta: false },
  { key: 'displayhub', label: 'Display Hub layout', beta: true },
  // Add more layouts here
] as const satisfies readonly LayoutType[];

const LAYOUT_PARAM = 'layout';

export function useRundownLayout() {
  const [searchParams, setSearchParams] = useSearchParams();
  const layout = searchParams.get(LAYOUT_PARAM) as (typeof LAYOUTS)[number]['key'] | null;

  const setLayout = (key: string | null) => {
    if (key) {
      searchParams.set(LAYOUT_PARAM, key);
    } else {
      searchParams.delete(LAYOUT_PARAM);
    }
    setSearchParams(searchParams);
  };

  return {
    layout,
    setLayout,
    isActive: (key: string) => layout === key,
  };
}
